import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { NotificationPanelService } from '@interacta-shared/feature-notification';
import { lastLoading } from '@interacta-shared/util';
import { AttachmentChipComponent } from '@interacta/ui-attachment';
import { IListAttachments } from '@interacta/util-post';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';
import { GalleryStateService } from '@modules/state/services/gallery-state.service';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-edit-post-attachments-notification',
    imports: [UserNotificationComponent, AttachmentChipComponent],
    templateUrl: './edit-post-attachments-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditPostAttachmentsNotificationComponent {
    private readonly notificationPanelService = inject(
        NotificationPanelService,
    );
    private readonly galleryStateService = inject(GalleryStateService);

    notification = input.required<UserNotificationEvent>();

    readonly attachment = computed(() =>
        this.notification().addedAttachments.length > 0
            ? this.notification().addedAttachments[0]
            : this.notification().updatedAttachments.length > 0
              ? this.notification().updatedAttachments[0]
              : this.notification().versionedAttachments.length > 0
                ? this.notification().versionedAttachments[0]
                : null,
    );
    readonly otherAttachments = computed(
        () =>
            this.notification().addedAttachments.length +
            this.notification().updatedAttachments.length +
            this.notification().versionedAttachments.length -
            1,
    );

    clickOnAttachment(event: Event, notification: UserNotificationEvent): void {
        event.stopPropagation();
        this.notificationPanelService.markNotificationAsRead(notification);
        const attachments = [
            ...notification.addedAttachments,
            ...notification.updatedAttachments,
            ...notification.versionedAttachments,
        ];

        const attachmentList: IListAttachments = {
            attachments,
            pageTokenInfo: lastLoading(),
            totalCount: attachments.length,
            isLoading: false,
            isError: false,
        };

        this.galleryStateService.openGallery(
            {
                feature: 'embedded',
                attachmentList,
            },
            0,
        );
    }
}
